"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayCallsWrapperTemplate = StringArrayCallsWrapperTemplate;
function StringArrayCallsWrapperTemplate() {
    return `
        function {stringArrayCallsWrapperName} (index, key) {
            index = index - {indexShiftAmount};

            const stringArray = {stringArrayFunctionName}();
            let value = stringArray[index];
                
            {decodeCodeHelperTemplate}

            return value;
        }
    `;
}
